<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        {
          name: 'Support Faq',
          to: {
            name: 'SupportFaq'
          }
        },
        {
          name: 'Edit',
          to: {
            name: 'SupportFaqEdit',
            params: {
              id: $route.params.id
            }
          }
        },
      ]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯Support Faq</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <SupportFaqCreateEdit></SupportFaqCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportFaqCreateEdit from '@/views/H-2__SupportFaq/c/SupportFaqCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    SupportFaqCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('supportFaq', ['faq']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getFaq(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('supportFaq', {
      getFaq: 'findById',
      saveFaq: 'save',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.saveFaq(this.faq).then(() => {
          this.$router.push({ name: 'SupportFaq' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
